module.exports = __webpack_public_path__ + "img/docs.a91fc15c.png";